<template lang="pug">
  SspLayout.top-up-wizard(area="core")
    template(slot="actions")
      button.ml15.btn.btn-primary(v-if="expansionLength" @click="save") Save & Exit
      button.btn.btn-default(@click="removeAllExpansions") Remove All Expansions
    .row
      CodeType(v-show="!expansion.codeType || (expansion.codeType && expansion.codeData)"  @type="setCodeType" :key="newPair" :pair="newPair")
      .col-sm-6.col-sm-offset-3
        CodeData(v-show="expansion.codeType && !expansion.codeData" :codeType="expansion.codeType" @codeData="setCodeData" @removeCurrentCodeData="removeCurrentCodeData" :predefinedExpansionCount="expansionLength")

    .row
      .col-sm-12
        CodeSummary(v-if="expansionLength" :codeData="expansions" @removeExpansion="removeExpansion")


</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'
import CodeType from './components/CodeType'
import CodeData from './components/CodeData'
import CodeSummary from './components/CodeSummary'

export default {
  data: () => ({
    expansion: {},
    expansions: [],
    expansionLength: null,
    newPair: 0
  }),
  created() {
    this.expansion = this.initData()
  },
  methods: {
    initData() {
      return {
        codeType: null,
        codeData: null
      }
    },
    createPayload() {
      this.expansionLength = this.expansion.codeData.codes ? this.expansion.codeData.codes.length : parseInt(this.expansion.codeData.codeCount, 10)
      const req = {
        type: this.expansion.codeType,
        name: this.expansion.codeData.name,
        codeConfiguration: {
          id: this.expansion.codeData.codeConfiguration.id
        },
        codeType: this.expansion.codeData.codeType ? this.expansion.codeData.codeType : null
      }

      if (this.expansion.codeType === 'KZ') {
        req.codeCount = parseInt(this.expansion.codeData.codeCount, 10)
        req.codeLength = this.expansion.codeData.codeLength
      } else if (this.expansion.codeType === 'EXT') {
        req.codes = this.expansion.codeData.codes
      }
      this.startNewExpansion()
      return req
    },
    save() {
      Core.createExpansion(this.orderId, { definitions: this.expansions })
        .then(() => {
          miniToastr.success('Expansion created')
          this.$router.push({ name: 'expansions', params: { id: this.orderId } })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    setCodeData(data) {
      this.expansion.codeData = data
      this.expansions.push(this.createPayload())
    },
    setCodeType(type) {
      this.expansion.codeType = type
      this.expansion.codeData = null
    },
    startNewExpansion() {
      this.newPair = this.newPair + 1
      this.expansion = this.initData()
    },
    removeExpansion(index) {
      this.expansions.splice(index, 1)
      if (this.expansions.length === 0) {
        this.expansionLength = null
      }
    },
    removeCurrentCodeData() {
      this.expansion = this.initData()
    },
    removeAllExpansions() {
      this.expansion = this.initData()
      this.expansions = []
      this.expansionLength = null
      this.newPair = 0
    }
  },
  computed: {
    isValid() {
      return this.expansions.length > 0
    },
    orderId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    CodeType,
    CodeData,
    CodeSummary
  }
}
</script>

<style lang="scss">
.top-up-wizard {
  .step-panel {
    min-height: 220px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/code/TopUpWizard.vue